import axios from "axios";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://api.gtalarm.it/v1" : "http://localhost:8083/v1";

const Api = {};

Api.login = (username, password) => {
  const url = `${BASE_URL}/login`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        username,
        password
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.changepwd = (oldPassword, newPassword, token) => {
  const url = `${BASE_URL}/changepwd`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        oldPassword,
        newPassword,
        token
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.resetpwd = (newPassword, token) => {
  const url = `${BASE_URL}/changepwdfromreset`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        newPassword,
        token
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.resetPassword = (username, env) => {
  const url = `${BASE_URL}/resetpwd`;

  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        username,
        env
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.user = () => {
  const url = `${BASE_URL}/user`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.subuser = () => {
  const url = `${BASE_URL}/subuser`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.fleets = () => {
  const url = `${BASE_URL}/user/fleets`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.routes = (contractId, from, to) => {
  // '2018-12-01T23:00:00Z';
  console.log(from);
  console.log(to);
  const fromStr = from.startOf("day").toFormat('yyyy-LL-dd') + 'T' + from.startOf("day").toFormat('HH:mm:ss') + 'Z';
  const toStr = to.endOf("day").toFormat('yyyy-LL-dd') + 'T' + to.endOf("day").toFormat('HH:mm:ss') + 'Z';
  const url = `${BASE_URL}/user/contracts/${contractId}/routes?from=${fromStr}&to=${toStr}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.exportRouteInXlsx = (contractId, routesDateFrom, routesDateTo) => {
  const from = routesDateFrom.startOf("day").toFormat('yyyy-LL-dd') + 'T' + routesDateFrom.startOf("day").toFormat('HH:mm:ss') + 'Z';
  const to = routesDateTo.endOf("day").toFormat('yyyy-LL-dd') + 'T' + routesDateTo.endOf("day").toFormat('HH:mm:ss') + 'Z';
  const url = `${BASE_URL}/user/contracts/${contractId}/routes/exportInXlsx?from=${from}&to=${to}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, { responseType: 'blob' })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.routeDetails = routeId => {
  const url = `${BASE_URL}/user/routes/${routeId}/details`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.requests = contractId => {
  const url = `${BASE_URL}/user/contracts/${contractId}/requests`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

Api.request = (contractId, deviceId, subuserId, command, parameters = "") => {
  const url = `${BASE_URL}/user/contracts/${contractId}/requests`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        deviceId,
        command,
        parameters,
        subuserId
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export default Api;
